import React, { Fragment } from 'react'

import { useMediaQueries, useCallback } from 'hooks'

import { goTo, urlTo } from 'helpers/router'

import Inner from 'components/_old/Inner/Inner.jsx'
import Width from 'components/_old/Width/Width'

import { GatewayDest } from 'components/atoms/Gateway'
import { DesktopLayout, MobileLayout } from 'components/atoms/Layouts'
import { NavigationBar } from 'components/atoms/NavigationBar'
import { Paper } from 'components/atoms/Paper'
import { Stack } from 'components/atoms/Stack'
import { Typography } from 'components/atoms/Typography'

import { MenuSection } from 'components/molecules/Menu/MenuSection'

import { DesktopFooter } from 'app/containers/Footer'
import { DesktopHeader } from 'app/containers/Header'

import { useProfile } from './useProfile'

const Profile = ({ location }): React.ReactElement => {
  const { desktop } = useMediaQueries()

  const {
    generalMenuItems,
    legalInformationMenuItems,
    fundingMenuItems,
    businessMenuItems,
    portfoliosMenuItems,
    isBusiness,
    saveScrollPosition,
  } = useProfile()

  const goBack = useCallback(() => {
    if (location?.query?.back) {
      goTo(location?.query?.back)
      return
    }

    goTo(urlTo('dashboard'))
  }, [location])

  const navbarNode = (
    <NavigationBar leftPartText="Back" onLeftPartClick={goBack}>
      <Typography tag="h1" size={desktop ? 32 : 20} lineHeight="small" weight="semibold">
        Settings
      </Typography>
    </NavigationBar>
  )

  const content = (
    <Stack vertical={48}>
      <MenuSection title="General" items={generalMenuItems} saveScrollPosition={saveScrollPosition} />

      {fundingMenuItems.length > 0 && (
        <MenuSection title="Funding" items={fundingMenuItems} saveScrollPosition={saveScrollPosition} />
      )}

      {isBusiness && businessMenuItems.length > 0 && (
        <MenuSection title="Business settings" items={businessMenuItems} saveScrollPosition={saveScrollPosition} />
      )}
      {portfoliosMenuItems.length > 0 && (
        <MenuSection title="Portfolios" items={portfoliosMenuItems} saveScrollPosition={saveScrollPosition} />
      )}

      <Paper bottom={desktop ? undefined : 48}>
        <MenuSection
          title="Legal information"
          items={legalInformationMenuItems}
          saveScrollPosition={saveScrollPosition}
        />
      </Paper>
    </Stack>
  )

  return (
    <Fragment>
      {desktop ? (
        <DesktopLayout
          header={<DesktopHeader />}
          footer={<DesktopFooter />}
          content={
            <Inner twoColumns>
              {navbarNode}

              <Paper top={40}>
                <Width size={30} center>
                  {content}
                </Width>
              </Paper>
            </Inner>
          }
        />
      ) : (
        <MobileLayout header={navbarNode} content={content} />
      )}

      <GatewayDest name="toasts" />
      <GatewayDest name="modals" />
    </Fragment>
  )
}

export { Profile }
